export const navItems = [
        { name: 'Home', path: '/' },
        { name: 'Lembawe9', path: '/lembawe9' },
        { name: 'راب الشوارع', path: '/راب-الشوارع' },
        { name: 'LHANGAR', path: '/lhangar' },
        { name: 'Music', path: '/music' },
        { name: 'Our Artists', path: '/artists' },
        { name: 'Gallery', path: '/gallery' },
        { name: 'Universe', path: '/universe' },
        { name: 'News', path: '/news' },
        { name: 'BURN IT OR BURN OUT', path: '/burnitorburnout' },
        { name: 'Merch', path: '/merch' },
        { name: 'Contact', path: '/contact' },
    ];